// components
import PageHeader from "../../../PageHeader/PageHeader";
import PageCardGrid from "../../components/PageCardGrid"
import PageState from "../../components/PageState";

export default  function FaellesskabAlle(){
    return(
        <PageState
            pageName="FaellesskabAlle"
            render={({ data }) => {

                return(
                    <div>
                        <PageHeader
                            image={data.PageHeader.imageUrl}
                            title={data.PageHeader.title}
                        />
                        <PageCardGrid content={data.pageContent}/>
                    </div>
                );
            }
        }/>
    );
}